import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import isEmpty from 'lodash/isEmpty'
import NumberFormat from 'react-number-format'

// Components
import Loader from '../../utils/Loader'

// State
import { userTokenUpdate } from '../../../store/actions/user'
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../../shared/vars'

class TaxValuesForm extends Component {
    constructor(props){
        super(props)
        this.state = {
           data: null,
           isLoading: true,
           updateLoading: false,
           updateErrors: {}
        }
    }

    componentDidMount(){
        this.loadData(this.props.province)
    }

    componentWillReceiveProps(newProps){
        // console.log(this.props.province, newProps.province)
        if(this.props.province !== newProps.province){
            this.loadData(newProps.province)
        }
    }

    loadData(province){
        const { user } = this.props

        this.setState({
            isLoading: true
        })

        const token = user.token
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token }
        return axios.get(REACT_APP_API_URL + 'locations/tax/' + province, { headers: AUTH_HEADER })
		.then((response) => {
            if(response.status !== 200 || (response.data.status && response.data.status !== 200)){
                this.setState({ isLoading: false, error: response.data.message })
            }else{
                this.setState({
                    isLoading: false,
                    data: { ...response.data }
                })
            }
		})
		.catch((err) => {
            if(err.response){
                this.setState({ isLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message })
            }else{
                this.setState({ isLoading: false, error: err.message })
            }
		})
    }

    handleNumberChange(id, valueObject){
        this.setState({
			data: {
                ...this.state.data,
                [id]: valueObject.value
            }
		})
    }

    handleInputChange(event){
        event.preventDefault()

		this.setState({
			data: {
                ...this.state.data,
                [event.target.id]: event.target.value
            }
		})
    }

    handleKeyPress(event, item_id){
		if (event.key === 'Enter'){
			this.handleSubmit()
		}
    }

    handleSubmit(){
        let { data } = this.state
        const { user } = this.props

        // Append some data from the parent component
        data.country = this.props.country
        data.province = this.props.province

        this.setState({
            updateErrors: {},
            updateLoading: true
        })

        // Tell parent about some state changes
        this.props.handleUpdates([
            {
                id: 'updateSuccess',
                value: ''
            },
            {
                id: 'updateLoading',
                value: true
            }
        ])

        const token = user.token
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token }
        return axios.post(REACT_APP_API_URL + 'locations/tax/' + data.province, data, { headers: AUTH_HEADER })
		.then((response) => {
            if(response.status !== 200 || (response.data.status && response.data.status !== 200)){
                this.setState({
                    updateLoading: false,
                    updateErrors: !isEmpty(response.data.errors) ? response.data.errors : { general: response.data.message }
                })

                this.props.handleUpdates([
                    {
                        id: 'errors',
                        value: response.data.errors
                    },
                    {
                        id: 'updateLoading',
                        value: false
                    }
                ])
            }else{
                this.setState({
                    updateLoading: false,
                    updateSuccess: response.data.message
                })

                this.props.userTokenUpdate('admin', response.data.token)

                // Tell the parent, about the great success
                this.props.handleUpdates([
                    {
                        id: 'updateSuccess',
                        value: response.data.message
                    },
                    {
                        id: 'updateLoading',
                        value: false
                    }
                ])
            }
		})
		.catch((err) => {
            if(err.response){
                this.setState({
                    updateLoading: false,
                    updateErrors: { general: err.response.data.error ? err.response.data.error : err.response.data.message }
                })
            }else{
                this.setState({
                    updateLoading: false,
                    updateErrors: { general: err.message }
                })
            }

            this.props.handleUpdates([
                {
                    id: 'updateLoading',
                    value: false
                }
            ])
		})
    }

    render() {
        return (
            <div>
                {this.state.isLoading ? (
                    <Loader />
                ) : (
                    <div>
                        <div className="floated-field-container">
                            <div className="form-field half-field">
                                <label>PST</label>

                                {this.state.updateErrors.pst &&
                                    <div className="error msg_animate">{this.state.updateErrors.pst}</div>
                                }
                                <NumberFormat placeholder="0.00" id="pst" value={this.state.data.pst} suffix={'%'} decimalScale={2} fixedDecimalScale={true}
                                    onKeyPress={e => this.handleKeyPress(e)}
                                    onValueChange={e => this.handleNumberChange('pst', e)}
                                />
                            </div>

                            <div className="form-field half-field">
                                <label>GST</label>

                                {this.state.updateErrors.gst &&
                                    <div className="error msg_animate">{this.state.updateErrors.gst}</div>
                                }
                                <NumberFormat placeholder="0.00" id="gst" value={this.state.data.gst} suffix={'%'} decimalScale={2} fixedDecimalScale={true}
                                    onKeyPress={e => this.handleKeyPress(e)}
                                    onValueChange={e => this.handleNumberChange('gst', e)}
                                />
                            </div>
                        </div>

                        <div className="form-field">
                            {this.state.updateErrors.harmonized &&
                                <div className="error msg_animate">{this.state.updateErrors.harmonized}</div>
                            }
                            <div className="custom-label checkbox-label no-bottom-margin">
                                <input type="checkbox" id="harmonized" value="1" checked={this.state.data.harmonized}
                                    onChange={e => this.handleInputChange(e)}
                                />
                                <label htmlFor="harmonized">Is Harmonized</label>
                            </div>
                        </div>

                        <div className="form-field">
                            <label>Point of Sale Rebate Rate</label>

                            {this.state.updateErrors.pos_rebate_rate &&
                                <div className="error msg_animate">{this.state.updateErrors.pos_rebate_rate}</div>
                            }
                            <NumberFormat placeholder="0.00" id="pos_rebate_rate" value={this.state.data.pos_rebate_rate} suffix={'%'} decimalScale={2} fixedDecimalScale={true}
                                onKeyPress={e => this.handleKeyPress(e)}
                                onValueChange={e => this.handleNumberChange('pos_rebate_rate', e)}
                            />
                        </div>

                        <div className="btn_container">
                            {this.state.updateErrors.general &&
                                <div className="error msg_animate">{this.state.updateErrors.general}</div>
                            }
                            <button className={'btn submit-btn' + (this.state.updateLoading ? ' loading' : '')} onClick={() => this.handleSubmit()} disabled={this.state.updateLoading}><span>Submit</span></button>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.admin
    }
}

export default connect(mapStateToProps, { userTokenUpdate })(TaxValuesForm)



// WEBPACK FOOTER //
// ./src/components/admin/taxes/TaxValuesForm.js